import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export default function EfectivoTab({
  efectivo,
  onEfectivoChange,
  redondeo,
  onRedondeoChange,
  handleImporteChange,
  ocultarRedondeo = false,
}) {
  const [localEfectivo, setLocalEfectivo] = useState(efectivo || "");
  const [localRedondeo, setLocalRedondeo] = useState(redondeo || "");

  // sincroniza cuando cambia desde afuera
  useEffect(() => {
    setLocalEfectivo(efectivo || "");
  }, [efectivo]);

  useEffect(() => {
    setLocalRedondeo(redondeo || "");
  }, [redondeo]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 2,
        alignItems: "flex-start",
        flexWrap: "wrap",
      }}
    >
      {/* EFECTIVO */}
      <Box sx={{ width: 260 }}>
        <Typography
          variant="body2"
          fontWeight={600}
          sx={{ mb: 0.5, color: "text.secondary" }}
        >
          Importe en efectivo
        </Typography>

        <TextField
          size="small"
          type="number"
          onWheel={(e) => e.target.blur()}
          sx={{
            "& input[type=number]": {
              MozAppearance: "textfield",
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& .MuiInputBase-root": {
              height: 38,
              borderRadius: 2,
            },
            "& .MuiInputBase-input": {
              fontSize: "0.92rem",
              fontWeight: 500,
              padding: "8px 10px",
            },
          }}
          value={localEfectivo}
          onChange={(e) => setLocalEfectivo(e.target.value)}
          onBlur={(e) => handleImporteChange(e, onEfectivoChange)}
          placeholder="0.00"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography
                  variant="body2"
                  fontWeight={700}
                  color="text.secondary"
                >
                  $
                </Typography>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* REDONDEO */}
      {!ocultarRedondeo && (
        <Box sx={{ width: 260 }}>
          <Box
            sx={{
              display: "flex",
              gap: 0.5,
              alignItems: "center",
              mb: 0.5,
            }}
          >
            <Typography variant="body2" fontWeight={600} color="text.secondary">
              Redondeo
            </Typography>

            <Tooltip
              title={
                <Typography component="span" fontWeight="bold" fontSize={12}>
                  Se va a generar un ajuste por el monto del redondeo.
                </Typography>
              }
            >
              <span>
                <InfoIcon
                  sx={{
                    fontSize: 16,
                    color: "text.disabled",
                  }}
                />
              </span>
            </Tooltip>
          </Box>

          <TextField
            size="small"
            type="number"
            onWheel={(e) => e.target.blur()}
            sx={{
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
              "& input[type=number]::-webkit-outer-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              "& input[type=number]::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              "& .MuiInputBase-root": {
                height: 38,
                borderRadius: 2,
              },
              "& .MuiInputBase-input": {
                fontSize: "0.92rem",
                fontWeight: 500,
                padding: "8px 10px",
              },
            }}
            value={localRedondeo}
            onChange={(e) => setLocalRedondeo(e.target.value)}
            onBlur={(e) => handleImporteChange(e, onRedondeoChange)}
            placeholder="0.00"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    color="text.secondary"
                  >
                    $
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      )}
    </Box>
  );
}
